{
  "open": "Terminal",
  "connect": "Connect to server",
  "guest": "Guests cannot open a terminal",
  "picker": {
    "title": "Connect to server",
    "description": "The panel connects to the server — a terminal over SSH, the Windows remote desktop or the server console — and shows the session here. The session runs while this browser tab stays open.",
    "project": "Project",
    "search": "Find a server",
    "searchPlaceholder": "Name or address",
    "servers": "Servers",
    "noServers": "The project has no servers.",
    "noMatch": "Nothing found.",
    "noProjects": "No project where you may open a terminal: guests cannot.",
    "off": "Server is off",
    "noAddress": "No public address",
    "guestProject": "You are a guest in this project",
    "otherServer": "Another server",
    "user": "Unix user",
    "userHint": "root by default. The panel remembers your choice for this server.",
    "userInvalid": "Latin letters, digits, “.”, “-” and “_”, up to 32 characters.",
    "auth": "How to sign in",
    "certificate": "Certificate (recommended)",
    "certificateHint": "A one-time key signed by your organisation's certificate authority, valid for 10 minutes. The server must trust the authority: see “Browser terminal” on the server page.",
    "password": "Password",
    "passwordHint": "The Unix password is used for one sign-in: the panel neither stores nor logs it.",
    "passwordField": "User's password",
    "submit": "Connect",
    "direct": "Signs in as {{user}}, certificate",
    "settings": "Connection settings for {{name}}",
    "certificateWorks": "Certificate sign-in to this server works (last time {{time}}).",
    "certificateUnknown": "The server has not accepted a certificate yet: it must trust the certificate authority first.",
    "setupLink": "Set up on the server page"
  },
  "workspace": {
    "single": "Single",
    "columns": "Side by side",
    "rows": "Stacked",
    "second": "Other pane",
    "layout": "Split view",
    "secondMenu": "Which terminal the other pane shows",
    "fontSmaller": "Smaller font",
    "fontLarger": "Larger font",
    "search": "Find in output",
    "searchNext": "Next match",
    "searchPrevious": "Previous match",
    "searchClose": "Close the search",
    "copy": "Copy selection",
    "selectFirst": "Select text in the terminal first.",
    "paste": "Paste",
    "pasteFailed": "The browser did not let us read the clipboard. Paste with Ctrl+Shift+V."
  },
  "failure": {
    "unreachable": {
      "title": "The server does not answer on SSH",
      "text": "The panel could not connect to port 22. A firewall may close it, or sshd is not running."
    },
    "timeout": {
      "title": "The server did not answer in time",
      "text": "No connection within 20 seconds. Check the firewall and that the server has booted."
    },
    "auth_failed": {
      "title": "Wrong password",
      "text": "The server did not accept this user's password. Type it again."
    },
    "certificate_not_trusted": {
      "title": "The server does not trust the certificate authority",
      "text": "The server refused the certificate. Run the command below on it (once, as root), or sign in with the password."
    },
    "host_key_changed": {
      "title": "The server's key has changed",
      "text": "The server showed another SSH key than last time. That happens after a rebuild — or when someone intercepts the connection. Trust the new key only if you changed the server yourself."
    },
    "shell_failed": {
      "title": "The server opened no command line",
      "text": "The sign-in worked, but no shell started. Try another user or the console."
    },
    "idle": {
      "title": "Session closed after inactivity",
      "text": "Nothing happened in the terminal for 30 minutes. Reconnect to go on."
    },
    "lifetime": {
      "title": "The session has ended",
      "text": "A session lasts up to 8 hours. Reconnect — the panel issues a new certificate."
    },
    "closed": {
      "title": "Session closed",
      "text": "The connection ended. Reconnect to go on."
    },
    "expired": {
      "title": "The session is stale",
      "text": "The connection link was used already or has expired. Reconnect."
    }
  },
  "hostKey": {
    "known": "Before",
    "offered": "Now",
    "accept": "Trust the new key"
  },
  "passwordRetry": "Sign in with password",
  "setup": {
    "title": "Browser terminal",
    "intro": "The panel signs in to the server over SSH with one-time certificates of your organisation's certificate authority. The server must trust that authority — once, with the command below. New servers created with “Browser terminal” trust it from their first boot.",
    "trusted": "Certificate sign-in works: last time {{time}}.",
    "notYet": "No certificate sign-in to this server yet.",
    "command": "Command for the server",
    "commandHint": "Run it as root (over SSH or in the console). It writes the authority's key to /etc/ssh, adds a TrustedUserCAKeys line to the sshd settings, checks them and reloads sshd; if sshd refuses the settings, everything stays as it was.",
    "copy": "Copy the command",
    "copied": "Command copied",
    "typeInConsole": "Type it in the console",
    "hostKey": "Server key (host key)",
    "hostKeyUnknown": "Shown after the first sign-in."
  },
  "reach": {
    "title": "Access to port 22",
    "open": "Open for the panel.",
    "blocked": "Closed by firewall: {{names}}. The panel cannot connect.",
    "unknown": "The panel's address is not configured, so the rules cannot be checked: port 22 is not open to everyone.",
    "noAddress": "The server has no public address for the terminal to reach.",
    "egress": "Panel address: {{ips}}",
    "allow": "Allow access from the panel's address",
    "allowHint": "Adds a rule to firewall “{{name}}”: inbound TCP 22 from {{ips}}.",
    "allowed": "Rule added to firewall “{{name}}”"
  },
  "settings": {
    "title": "Terminal settings",
    "description": "Font, size and colours of every terminal in this browser. Changes show at once, open sessions included.",
    "searchHint": "Or Ctrl+Shift+F in the terminal (⌘+Shift+F on a Mac).",
    "preview": "How it looks",
    "sampleWarn": "warning",
    "sampleError": "error",
    "sampleComment": "a comment",
    "fontSize": "Font size",
    "fontSizeValue": "Font size: {{size}}",
    "font": "Font",
    "systemFont": "System monospace font",
    "noCyrillic": "no Cyrillic",
    "theme": "Colour theme",
    "panelTheme": "Like the panel",
    "panelThemeHint": "Light or dark, following the panel's theme",
    "dark": "Dark",
    "light": "Light",
    "reset": "Reset",
    "done": "Done"
  },
  "touchKeys": {
    "label": "Terminal keys",
    "esc": "Escape",
    "tab": "Tab",
    "ctrl": "Ctrl: next key with Ctrl",
    "alt": "Alt: next key with Alt",
    "left": "Arrow left",
    "up": "Arrow up",
    "down": "Arrow down",
    "right": "Arrow right",
    "slash": "Slash",
    "hideKeyboard": "Hide the keyboard",
    "showKeyboard": "Show the keyboard"
  }
}
